<template>
  <section class="container py-[100px] calculate-bike-size">
    <h1
      class="mb-4 md:mb-[32.25px] mt-0 text-[22px] font-ff-good-pro-cond uppercase font-bold !leading-[32px] md:text-[32px] md:!leading-[40px] text-center text-secondary"
    >
      {{ $t("common.calculate_your_size") }}
    </h1>

    <ul
      class="flex justify-between md:justify-center tabs md:gap-x-[86px] font-ff-good-pro-cond text-sm font-medium"
    >
      <li class="relative inline-flex flex-col flex-1 md:flex-none">
        <span
          :class="[
            currentTab == 'gender'
              ? ' border-primary'
              : ' border-primary bg-primary',
          ]"
          class="items-center justify-center w-4 h-4 border-2 rounded-full"
        ></span>
        <span class="mt-1 ml-1 md:ml-0 md:text-center text-primary">1</span>
        <span
          class="absolute md:!w-[86px] h-0.5 left-4 md:left-full top-[7px]"
          style="width: calc(100% - 16px)"
          :class="[currentTab != 'gender' ? ' bg-primary' : ' bg-[#D9D9D9]']"
        ></span>
      </li>
      <li class="relative inline-flex flex-col flex-1 md:flex-none">
        <span
          class="items-center justify-center w-4 h-4 border-2 rounded-full"
          :class="[
            currentTab == 'bike-modal'
              ? ' border-primary'
              : currentTab == 'height' || currentTab == 'inner-leg-length'
              ? ' border-primary bg-primary'
              : 'border-dark-gray-400 ',
          ]"
        ></span>
        <span
          class="mt-1 ml-1 md:ml-0 md:text-center"
          :class="currentTab != 'gender' ? ' text-primary' : ' text-black '"
          >2
        </span>
        <span
          class="absolute md:!w-[86px] h-0.5 bg-[#D9D9D9] left-4 md:left-full top-[7px]"
          style="width: calc(100% - 16px)"
          :class="[
            currentTab == 'height' || currentTab == 'inner-leg-length'
              ? ' bg-primary'
              : ' bg-[#D9D9D9]',
          ]"
        ></span>
      </li>
      <li class="relative inline-flex flex-col flex-1 md:flex-none">
        <span
          class="items-center justify-center w-4 h-4 border-2 rounded-full"
          :class="[
            currentTab == 'height'
              ? ' border-primary'
              : currentTab == 'inner-leg-length'
              ? ' border-primary bg-primary'
              : 'border-dark-gray-400 ',
          ]"
        ></span>
        <span
          class="mt-1 ml-1 md:ml-0 md:text-center"
          :class="
            currentTab != 'gender' && currentTab != 'bike-modal'
              ? ' text-primary'
              : ' text-black '
          "
          >3
        </span>
        <span
          class="absolute md:!w-[86px] h-0.5 bg-[#D9D9D9] left-4 md:left-full top-[7px]"
          style="width: calc(100% - 16px)"
          :class="[
            currentTab == 'inner-leg-length' ? ' bg-primary' : ' bg-[#D9D9D9]',
          ]"
        ></span>
      </li>
      <li class="inline-flex flex-col">
        <span
          :class="[
            currentTab == 'inner-leg-length'
              ? ' border-primary'
              : ' border-dark-gray-400',
          ]"
          class="items-center justify-center w-4 h-4 border-2 rounded-full border-dark-gray-400"
        ></span>
        <span
          class="mt-1 text-center"
          :class="
            currentTab == 'inner-leg-length' ? ' text-primary' : ' text-black '
          "
          >4
        </span>
      </li>
    </ul>
    <XyzTransitionGroup
      id="tabs"
      :xyz="`fade duration-50 small-3 appear-small-0 stagger-0 ${
        isBack ? 'left' : 'right'
      }`"
      appear-visible
    >
      <CcbsChooseYourGender
        @next="getCurrentTab"
        v-if="currentTab == 'gender'"
      />
      <CcbsChooseYourBikeOption
        @next="getCurrentTab"
        @back="getCurrentBackTab"
        v-else-if="currentTab == 'bike-modal'"
      />
      <CcbsChooseYourHeight
        @next="getCurrentTab"
        @back="getCurrentBackTab"
        v-else-if="currentTab == 'height'"
      />
      <CcbsChooseYourInnerLegLength
        @back="getCurrentBackTab"
        @next="getCurrentTab"
        v-else-if="currentTab == 'inner-leg-length'"
      />
    </XyzTransitionGroup>
  </section>
</template>
<script setup>
const currentTab = ref("gender");
const isBack = ref(false);
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";

const calculateBikeSizeStore = useCalculateBikeSizeStore();

function getCurrentBackTab(tab) {
  isBack.value = true;
  currentTab.value = tab;
  calculateBikeSizeStore.setTab(tab);
}
function getCurrentTab(tab) {
  isBack.value = false;
  currentTab.value = tab;
  calculateBikeSizeStore.setTab(tab);
}
</script>
<style scoped>
.calculate-bike-size .wizard .xyz-out {
  @apply !hidden;
}
</style>